import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePageSeo, JsonLd, SITE_URL } from "../components/common";

export default function Cartomancie() {
  usePageSeo({
    title: "Cartomancie intuitive : ma façon de lire les cartes",
    description: "La cartomancie intuitive de Noëmie : lecture des cartes guidée par l'intuition et les ressentis, à distance. Un éclairage doux, jamais une prédiction certaine.",
    path: "/cartomancie",
  });
  return (
    <div className="home-dark min-h-[80vh]">
      <JsonLd data={{
        "@context": "https://schema.org", "@type": "Service",
        name: "Cartomancie intuitive", serviceType: "Lecture intuitive des cartes",
        provider: { "@id": `${SITE_URL}/#noemie` }, areaServed: "FR",
        description: "Cartomancie intuitive à distance : lecture des cartes guidée par l'intuition et les ressentis.",
        url: `${SITE_URL}/cartomancie`,
      }} />
      <div className="container-x py-12 sm:py-20 fade-up max-w-3xl">
        <div className="eyebrow mb-3 !text-[#DFC07B]">Cartomancie</div>
        <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#F9F5EE]">Cartomancie intuitive : ma façon de lire les cartes</h1>
        <div className="gold-divider my-6 w-28" />
        <div className="space-y-5 text-[#E7DCEA] leading-relaxed text-lg">
          <p>La cartomancie, c'est l'art de lire les cartes. Chez moi, elle est avant tout <strong>intuitive</strong> : je m'appuie sur mes ressentis, les symboles et les messages qui se présentent plutôt que sur une grille d'interprétation figée.</p>
          <p>Les cartes sont un support. Ce sont mon intuition et ma sensibilité qui donnent vie à la lecture, pour t'offrir un éclairage sur ta situation et des pistes de réflexion.</p>
          <p>Je ne présente jamais mes ressentis comme des vérités absolues : une lecture peut éclairer un chemin, elle ne le choisit jamais à ta place. Tu gardes toujours ton libre arbitre.</p>
        </div>
        <div className="mt-9 flex flex-wrap gap-3">
          <Link to="/guidances" className="btn-primary" data-testid="seo-cta-tirages">Découvrir mes tirages intuitifs <ArrowRight size={16} /></Link>
          <Link to="/a-propos" className="btn-ghost-gold">À propos de Noëmie</Link>
        </div>
      </div>
    </div>
  );
}
